import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

export const routePaths = {
  cataloghi: {
    gestione: '/gestioneCataloghi',
  }
}

export const hpRouteConfig = [
  {
    routes: [
      {
        path: '/login',
        component: React.lazy(() => import('./Login/')),
      },
      // {
      //   path: '/test1',
      //   component: React.lazy(() => import('./Zone/Test1')),
      // },
    ]
  },
  {
    auth: [RoutePermittedRole.Gestore],
    routes: [
      {
        path: '/registraPartner',
        component: React.lazy(() => import('./GestionePartners/RegistraPartner')),
      },
      {
        path: '/nuovoContratto',
        component: React.lazy(() => import('./Contratti/NuovoContratto')),
      },
      {
        path: '/figureProfessionali',
        component: React.lazy(() => import('./FigureProfessionali/FigureProfessionali')),
      },
      // {
      //   path: '/newSelezioneGiorni',
      //   component: React.lazy(() => import('./ConfigurazioneSlot/MOCK_SelezioneGiorni')),
      //   // component: React.lazy(() => import('./ConfigurazioneSlot/Steps/Step5Drawer')),
      // },

      // {
      //   path: '/elencoListini',
      //   component: React.lazy(() => import('./GestionePartners/ElencoListini')),
      // },
      {
        path: '/elencoListini',
        component: React.lazy(() => import('./GestioneListini/ElencoTipologieListino')),
      },
      {
        path: '/infoListino',
        component: React.lazy(() => import('./GestioneListini/InfoTipologiaListino')),
      },

      {
        path: '/elencoPrestazioni',
        component: React.lazy(() => import('./GestionePrestazioni/ListaPrestazioni')),
      },
      {
        path: '/aggiungiPrestazione',
        component: React.lazy(() => import('./GestionePrestazioni/AggiungiPrestazione')),
      },
      {
        path: '/infoPrestazione',
        component: React.lazy(() => import('./GestionePrestazioni/ModificaPrestazione')),
      },

      {
        path: '/elencoZone',
        component: React.lazy(() => import('./GestioneZone/ListaZone')),
      },
      {
        path: '/aggiungiZona',
        component: React.lazy(() => import('./GestioneZone/AggiungiZona')),
      },
      {
        path: '/infoZona',
        component: React.lazy(() => import('./GestioneZone/ModificaZona')),
      },
      
      {
        path: '/elencoContratti',
        component: React.lazy(() => import('./Contratti/ElencoContratti')),
      },
      {
        path: '/infoContratto',
        component: React.lazy(() => import('./Contratti/ModificaContratto')),
      },
    ],
  },
  {
    auth: [RoutePermittedRole.Gestore,RoutePermittedRole.CentraleOperativa,RoutePermittedRole.Amministrativo],
    routes: [
      {
        path: '/richiestePrenotazioni',
        component: React.lazy(() => import('./RichiestaPrenotazione/ElencoRichiestePrenotazioni')),
      },
      {
        path: '/infoRichiestaPrenotazione',
        component: React.lazy(() => import('./RichiestaPrenotazione/InfoRichiestaPrenotazione')),
      },
      {
        path: '/prenotazioneDomiciliare',
        component: React.lazy(() => import('./RichiestaPrenotazione/PrenotazioneDomiciliarePage')),
      },
      {
        path: '/modificaPrenotazioneDomiciliare',
        component: React.lazy(() => import('./RichiestaPrenotazione/ModificaPrenotazioneDomiciliare')),
      },
      // {
      //   path: '/infoPrenotazione',
      //   component: React.lazy(() => import('./Prenotazioni/DettaglioPrenotazione')),
      // },
      {
        path: '/infoPrenotazione',
        component: React.lazy(() => import('./Prenotazioni/DettaglioPrenotazionePage')),
      },

      {
        path: '/agendaDomiciliare',
        component: React.lazy(() => import('./RichiestaPrenotazione/Agenda/AgendaDomiciliare')),
      },
    ],
  },
  {
    auth: [RoutePermittedRole.Gestore,RoutePermittedRole.Amministrativo],
    routes: [
      {
        path: '/elencoUtenti',
        component: React.lazy(() => import('./Utenti/ListaUtenti')),
      },
      {
        path: '/registraUtente',
        component: React.lazy(() => import('./Register/RegistraUtente')),
      },
      {
        path: '/infoUtente',
        component: React.lazy(() => import('./Register/InfoUtente')),
      },
    ]
  },
  {
    auth: [RoutePermittedRole.Gestore,RoutePermittedRole.Amministrativo,RoutePermittedRole.Freelancer],
    routes: [
      {
        path: '/elencoPartners',
        component: React.lazy(() => import('./GestionePartners/ListaPartners')),
      },
      {
        path: '/infoPartner',
        component: React.lazy(() => import('./GestionePartners/InfoPartner/ModificaPartner')),
      },

      {
        path: '/gestioneSlot',
        // component: React.lazy(() => import('./GestionePartners/ConfigurazioneSlot')),
        component: React.lazy(() => import('./ConfigurazioneSlot/ConfigurazioneSlot')),
      },

      {
        path: '/gestioneCataloghi',
        component: React.lazy(() => import('./GestioneCatalogo/CataloghiPage')),
      },

      {
        path: '/elencoAmbulatori',
        component: React.lazy(() => import('./HomePoints/ElencoHomePoints')),
      },
      {
        path: '/aggiungiAmbulatorio',
        component: React.lazy(() => import('./HomePoints/NewHomePoint')),
      },
      {
        path: '/infoAmbulatorio',
        component: React.lazy(() => import('./HomePoints/EditHomePoint')),
      },

      // {
      //   path: '/gestioneListini',
      //   component: React.lazy(() => import('./GestioneListini/GestioneListiniRoute')),
      // },

      {
        path: '/registraAssistito',
        component: React.lazy(() => import('./GestioneAssistiti/RegistrazioneAssistito')),
      },
      {
        path: '/infoAssistito',
        component: React.lazy(() => import('./GestioneAssistiti/ModificaAssistito')),
      },
      {
        path: '/elencoAssistiti',
        component: React.lazy(() => import('./GestioneAssistiti/ListaAssistiti')),
      },

      {
        path: '/CupBooking',
        component: React.lazy(() => import('./CupBooking/CupBookingPage')),
      },
      {
        path: '/modificaPrenotazione',
        component: React.lazy(() => import('./Prenotazioni/ModificaPrenotazione')),
      },

      {
        path: '/elencoDispositivi',
        component: React.lazy(() => import('./Dispositivi/ElencoDispositivi')),
      },

      {
        path: '/inserisciRichiestaPrenotazione',
        // component: React.lazy(() => import('./ListaAttesa/AddListaAttesa')),
        component: React.lazy(() => import('./RichiestaPrenotazione/AddRichiestaPrenotazionePage')),
      },
      {
        path: '/prenotaListaAttesa',
        component: React.lazy(() => import('./ListaAttesa/PrenotaListaAttesa')),
      },
    ]
  },
  {
    auth: [RoutePermittedRole.Gestore,RoutePermittedRole.Amministrativo,RoutePermittedRole.Freelancer,RoutePermittedRole.Dipendente],
    routes: [
      {
        path: '/Profilo',
        component: React.lazy(() => import('./MyProfile/MyProfile')),
      },
      {
        path: '/Home',
        component: React.lazy(() => import('./HomePage/HomePage')),
      },


      {
        path: '/elencoPrenotazioni',
        component: React.lazy(() => import('./Prenotazioni/ElencoPrenotazioniPage')),
      },
      // {
      //   path: '/listaPartners',
      //   component: React.lazy(() => import('./ListaPartners/ListaPartners')),
      // },
      /*{
        path: '/prova',
        component: React.lazy(() => import('./Prova/Prova')),
      },*/
     /* {
        path: '/register',
        component: React.lazy(() => import('./Register/')),
      },
      {
        path: '/passwordDimenticata',
        component: React.lazy(() => import('./PasswordDimenticata/RecuperaPasswordStepper')),
      },
      {
        path: '/confermaRegistrazione',
        component: React.lazy(() => import('./ConfirmEmail/ConfirmEmail')),
      },*/
      // {
      //   path: '/elencoPrestazioni',
      //   component: React.lazy(() => import('./GestionePrestazioni/ListaPrestazioni')),
      // },
      // {
      //   path: '/modificaPrestazioneEdit',
      //   component: React.lazy(() => import('./GestionePrestazioni/Edit')), ??
      // },
      // {
      //   path: '/editPrestazione',
      //   component: React.lazy(() => import('./GestionePrestazioni/Edit')),
      // },
      /*
      {
        path: '/personeACarico',
        component: React.lazy(() => import('./ListaPersoneACarico/PersoneACarico')),
      },
      {
        path: '/addSupervisoredMinor',
        component: React.lazy(() => import('./AddSupervisoredMinor/AddSupervisoredMinor')),
      },
      {
        path: '/editSupervisoredMinorProfile',
        component: React.lazy(() => import('./SupervisoredMinorProfile/SupervisoredMinorForm')),
      },/*

      {
        path: '/prestazioniAcquistate/pendingPayment',
        component: React.lazy(() => import('./PrestazioniAcquistate/PrestazioniAcquistate')),
      },*/
    ],
  }
];
